import { Routes } from '@angular/router';
import {SupportEnterComponent} from './components/support-enter/support-enter.component';
import {SupportDepartmentsComponent} from './components/support-departments/support-departments.component';
import {ChatListComponent} from './components/chat-list/chat-list.component';
import {ChatComponent} from './components/chat/chat.component';
import {StandardSolutionComponent} from './components/standard-solution/standard-solution.component';
import {CreateTicketComponent} from './components/create-ticket/create-ticket.component';
import {TripListComponent} from './components/trip-list/trip-list.component';
import {TripDetailsComponent} from './components/trip-details/trip-details.component';
import {TicketReasonComponent} from './components/ticket-reason/ticket-reason.component';
import {TicketCommentComponent} from './components/ticket-comment/ticket-comment.component';

export const routes: Routes = [
  {path: 'enter', component: SupportEnterComponent},
  {path: 'chat-list', component: ChatListComponent},
  {path: 'chat', component: ChatComponent},
  {path: 'departments', component: SupportDepartmentsComponent},
  {path: 'standard-solution', component: StandardSolutionComponent},
  {path: 'create-ticket', component: CreateTicketComponent},
  {path: 'trip-list', component: TripListComponent},
  {path: 'trip-details', component: TripDetailsComponent},
  {path: 'ticket-reason', component: TicketReasonComponent},
  {path: 'ticket-comment', component: TicketCommentComponent},
  {path: '', redirectTo: 'enter', pathMatch: 'full'}
];
